function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { Text, mergeStyleSets, TextField, Separator, Checkbox, Dialog, PrimaryButton, Stack, IconButton, ButtonType, DefaultButton, Link, FontIcon } from '@fluentui/react';
import { NeutralColors, SharedColors } from '@fluentui/theme';
import { storeFeedback } from '@shared/services/feedback';
import { Constants } from '@shared/utils/constants';
import { useSpzaInstrumentService } from '@shared/hooks';
import { getWindow } from '@shared/services/window';
import { SubmittedModal } from '@shared/components/modals/submittedModal';
import { useLocation } from 'react-router-dom';
const subTextStyles = {
    root: {
        color: NeutralColors.gray130,
        lineHeight: 20
    }
};
export const FeatureFeedbackSubmittedModal = ({ hidden, onDismiss, context })=>{
    return /*#__PURE__*/ _jsx(SubmittedModal, {
        hidden: hidden,
        onDismiss: onDismiss,
        title: context.loc('Nps_SubmittedModal_Title', 'Feedback received'),
        context: context,
        children: /*#__PURE__*/ _jsx(Text, {
            block: true,
            styles: subTextStyles,
            children: context.loc('Nps_SubmittedModal_Summary_Text', 'Thanks for taking the time to share your thoughts!')
        })
    });
};
const DIALOG_MAX_WIDTH = 560;
const DIALOG_MIN_WIDTH = 300;
const DIALOG_MINI_MODE_WIDTH = 480;
const NO_SCORE = -1;
const buttonStyles = {
    root: {
        minWidth: 40,
        height: 48,
        maxWidth: 40,
        border: '1px solid #E1E3E5'
    },
    rootChecked: {
        color: NeutralColors.white,
        backgroundColor: SharedColors.cyanBlue10
    },
    rootCheckedHovered: {
        color: NeutralColors.white,
        backgroundColor: SharedColors.cyanBlue10
    }
};
const contentStyles = mergeStyleSets({
    feedback: {
        width: 'auto',
        height: 'auto'
    },
    defaultText: [
        {
            color: NeutralColors.gray130
        }
    ],
    stackdiv: {
        display: 'flex',
        flexDirection: 'column'
    },
    openQuestionDiv: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 40
    },
    checksDiv: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 40
    },
    title: {
        fontSize: 20,
        lineHeight: 28,
        fontWeight: 600
    },
    scoreDiv: {
        marginTop: 48
    },
    checkBox: {
        marginTop: 16,
        lineHeight: 16
    },
    scorePanel: {
        marginTop: 18
    },
    scoreSubtitle: {
        lineHeight: 20,
        fontSize: 14,
        fontWeight: 600
    },
    scoreMiniSecondLine: {
        marginTop: 8
    },
    checksSubtitle: {
        lineHeight: 20,
        fontSize: 14,
        fontWeight: 600
    },
    openQuestionTextField: {
        height: 96
    },
    inputSectionSeparator: {
        marginTop: 32
    },
    emailConsentCheck: {
        marginTop: 9
    },
    footer: {
        marginTop: 5,
        height: 96
    },
    privacyStatement: {
        marginTop: 7
    },
    submitButton: {
        alignSelf: 'start',
        width: 86,
        lineHeight: 24,
        marginTop: 9
    },
    faceButtonSelected: {
        backgroundColor: NeutralColors.gray20
    },
    faceButtonNotSelected: {
        backgroundColor: 'transparent'
    },
    requiredIcon: {
        fontSize: 7,
        padding: 2,
        color: '#A80000'
    },
    closeButton: {
        alignSelf: 'end',
        float: 'right'
    },
    closeIcon: {
        fontSize: 16,
        color: NeutralColors.gray160
    },
    closeIconRoot: {
        width: 24,
        height: 24
    }
});
export const scoreValues = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
export const scoreValuesMiniLine1 = [
    0,
    1,
    2,
    3,
    4,
    5
];
export const scoreValuesMiniLine2 = [
    6,
    7,
    8,
    9,
    10
];
export function FeatureFeedbackScoreSection({ viewContent, score, onScoreChange }, context) {
    var _getWindow;
    const miniMode = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.innerWidth) <= DIALOG_MINI_MODE_WIDTH;
    return /*#__PURE__*/ _jsxs("div", {
        className: contentStyles.scoreDiv,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                verticalAlign: "center",
                horizontal: true,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: contentStyles.scoreSubtitle,
                        children: (viewContent === null || viewContent === void 0 ? void 0 : viewContent.scoreTitle) || context.loc('Feature_Feedback_Score_Title', 'How valuable do you find the information provided by LinkedIn?')
                    }),
                    /*#__PURE__*/ _jsx(FontIcon, {
                        iconName: "Asterisk",
                        className: contentStyles.requiredIcon
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                className: contentStyles.scorePanel,
                tokens: {
                    childrenGap: 8
                },
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        horizontal: true,
                        horizontalAlign: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                variant: "smallPlus",
                                className: contentStyles.defaultText,
                                children: (viewContent === null || viewContent === void 0 ? void 0 : viewContent.scoreMinLabel) || context.loc('Feature_Feedback_Score_Min_Title', 'Min')
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                variant: "smallPlus",
                                className: contentStyles.defaultText,
                                children: viewContent.scoreMaxLabel || context.loc('Feature_Feedback_Score_Max_Title', 'Max')
                            })
                        ]
                    }),
                    miniMode ? /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Stack, {
                                horizontal: true,
                                tokens: {
                                    childrenGap: 8
                                },
                                children: scoreValuesMiniLine1.map((ratingValue)=>/*#__PURE__*/ _jsx(DefaultButton, {
                                        toggle: true,
                                        buttonType: score === ratingValue ? ButtonType.primary : ButtonType.default,
                                        checked: score === ratingValue,
                                        styles: buttonStyles,
                                        text: `${ratingValue}`,
                                        onClick: ()=>onScoreChange(ratingValue)
                                    }, ratingValue))
                            }),
                            /*#__PURE__*/ _jsx(Stack, {
                                className: contentStyles.scoreMiniSecondLine,
                                horizontal: true,
                                tokens: {
                                    childrenGap: 8
                                },
                                children: scoreValuesMiniLine2.map((ratingValue)=>/*#__PURE__*/ _jsx(DefaultButton, {
                                        toggle: true,
                                        buttonType: score === ratingValue ? ButtonType.primary : ButtonType.default,
                                        checked: score === ratingValue,
                                        styles: buttonStyles,
                                        text: `${ratingValue}`,
                                        onClick: ()=>onScoreChange(ratingValue)
                                    }, ratingValue))
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(Stack, {
                        horizontal: true,
                        tokens: {
                            childrenGap: 8
                        },
                        children: scoreValues.map((ratingValue)=>/*#__PURE__*/ _jsx(DefaultButton, {
                                toggle: true,
                                buttonType: score === ratingValue ? ButtonType.primary : ButtonType.default,
                                checked: score === ratingValue,
                                styles: buttonStyles,
                                text: `${ratingValue}`,
                                onClick: ()=>onScoreChange(ratingValue)
                            }, ratingValue))
                    })
                ]
            })
        ]
    });
}
export function FeatureFeedbackTitleSection({ viewContent, onDialogDismissed }, context) {
    return /*#__PURE__*/ _jsx("div", {
        className: contentStyles.stackdiv,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    className: contentStyles.title,
                    children: (viewContent === null || viewContent === void 0 ? void 0 : viewContent.title) || context.loc('Feature_Feedback_Dialog_Title', 'We’d love your feedback')
                }),
                /*#__PURE__*/ _jsx(IconButton, {
                    className: contentStyles.closeButton,
                    styles: {
                        icon: contentStyles.closeIcon,
                        root: contentStyles.closeIconRoot
                    },
                    iconProps: {
                        iconName: 'ChromeClose'
                    },
                    "aria-label": context.loc('Dialog_Close', 'Close'),
                    onClick: onDialogDismissed
                })
            ]
        })
    });
}
export function FeatureFeedbackChecksSection({ viewContent, checks, setCheckChange }, context) {
    var _viewContent_checks;
    return /*#__PURE__*/ _jsxs("div", {
        className: contentStyles.checksDiv,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: contentStyles.checksSubtitle,
                children: (viewContent === null || viewContent === void 0 ? void 0 : viewContent.checksTitle) || context.loc('Feature_Feedback_Checks_Title', 'Which of the following contributed to your experience?')
            }),
            viewContent === null || viewContent === void 0 ? void 0 : (_viewContent_checks = viewContent.checks) === null || _viewContent_checks === void 0 ? void 0 : _viewContent_checks.map((featureCheckDef)=>{
                return /*#__PURE__*/ _jsx(Checkbox, {
                    className: contentStyles.checkBox,
                    label: featureCheckDef.text,
                    checked: checks[featureCheckDef.key] && checks[featureCheckDef.key],
                    onChange: (element, checked)=>setCheckChange(featureCheckDef.key, checked)
                }, featureCheckDef.key);
            })
        ]
    });
}
export function FeatureFeedbackInputSection({ viewContent, userComment, setUserComment }, context) {
    return /*#__PURE__*/ _jsx("div", {
        className: contentStyles.openQuestionDiv,
        children: /*#__PURE__*/ _jsx(TextField, {
            value: userComment,
            label: (viewContent === null || viewContent === void 0 ? void 0 : viewContent.openQuestionFieldTitle) || context.loc('Feature_Feedback_Open_Question_Title', 'What can we do to improve your experience?'),
            placeholder: (viewContent === null || viewContent === void 0 ? void 0 : viewContent.openQuestionFieldPlaceholder) || context.loc('Feature_Feedback_Open_Question_Placeholder', 'Tell us about your experience...'),
            className: contentStyles.openQuestionTextField,
            multiline: true,
            rows: 4,
            onChange: (ev, newValue)=>setUserComment(newValue)
        })
    });
}
export function FeatureFeedbackEmailSection({ email, emailConsent, setEmailConsent }, context) {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Separator, {
                className: contentStyles.inputSectionSeparator
            }),
            email && /*#__PURE__*/ _jsx(Checkbox, {
                label: context.locParams('Feature_Feedback_Email_Concent', [
                    email
                ], `Microsoft can email you to ${email} about your feedback`),
                className: contentStyles.emailConsentCheck,
                checked: emailConsent,
                onChange: (ev, checked)=>{
                    setEmailConsent(checked);
                }
            })
        ]
    });
}
export function FeatureFeedbackFooterSection({ onSubmitClick, submitDisabled }, context) {
    return /*#__PURE__*/ _jsxs("div", {
        className: contentStyles.stackdiv,
        children: [
            /*#__PURE__*/ _jsx(Link, {
                underline: true,
                target: "_blank",
                rel: "noreferrer",
                href: "https://aka.ms/AppSourcePrivacyStatement",
                className: contentStyles.privacyStatement,
                children: context.loc('Feedback_privacy', 'Privacy statement')
            }),
            /*#__PURE__*/ _jsx(PrimaryButton, {
                disabled: submitDisabled,
                onClick: onSubmitClick,
                className: contentStyles.submitButton,
                text: context.loc('Feature_FeedbackSubmit_Button', 'Submit')
            })
        ]
    });
}
/* Feature feedback dialog.
   This component can be customize to allow getting feedback for diffrent features.
   To cistomize its content use 'viewContent' property.
   The component handle feedback submission (to log/data table) and trigger event after feedback has been submitted.
   When dialod in react component tree, it is always visible.
   User should handle dialog visibility externaly by using 'onFeedbackSubmitted' and 'onDialogDismissed' callbacks.
*/ function FeatureFeedbackInternal({ featureName, viewContent, email, onFeedbackSubmitted, onDialogDismissed }) {
    const location = useLocation();
    const [score, setScore] = useState(NO_SCORE);
    const [emailConsent, setEmailConsent] = useState(false);
    const [userComment, setUserComment] = useState('');
    const [instrument] = useSpzaInstrumentService();
    const [checks, setChecks] = React.useState((viewContent === null || viewContent === void 0 ? void 0 : viewContent.checks) ? viewContent.checks.map((featureCheck)=>{
        return {
            [featureCheck.key]: false
        };
    }) : []);
    const setCheckChange = (key, checked)=>setChecks(_object_spread_props(_object_spread({}, checks), {
            [key]: checked
        }));
    const getEmail = ()=>{
        return emailConsent ? email : '';
    };
    const onSubmitClick = ()=>{
        const userFeedbackContent = {
            score,
            checks,
            comments: userComment,
            email: getEmail()
        };
        // New logger
        storeFeedback({
            action: Constants.Telemetry.Action.CVA,
            actionModifier: featureName,
            details: JSON.stringify(userFeedbackContent)
        });
        // Old logger
        const payload = {
            page: location === null || location === void 0 ? void 0 : location.pathname,
            action: Constants.Telemetry.Action.CVA,
            actionModifier: featureName,
            details: JSON.stringify(userFeedbackContent),
            isFeedback: true
        };
        instrument.probe('logAndFlushTelemetryInfo', payload);
        onFeedbackSubmitted === null || onFeedbackSubmitted === void 0 ? void 0 : onFeedbackSubmitted();
    };
    return /*#__PURE__*/ _jsx(Dialog, {
        maxWidth: DIALOG_MAX_WIDTH,
        minWidth: DIALOG_MIN_WIDTH,
        hidden: false,
        onDismiss: onDialogDismissed,
        children: /*#__PURE__*/ _jsxs("div", {
            className: contentStyles.feedback,
            children: [
                /*#__PURE__*/ _jsx(FeatureFeedbackTitleSection, {
                    viewContent: viewContent,
                    onDialogDismissed: onDialogDismissed
                }),
                /*#__PURE__*/ _jsx(FeatureFeedbackScoreSection, {
                    viewContent: viewContent,
                    onScoreChange: setScore,
                    score: score
                }),
                /*#__PURE__*/ _jsx(FeatureFeedbackChecksSection, {
                    viewContent: viewContent,
                    checks: checks,
                    setCheckChange: setCheckChange
                }),
                /*#__PURE__*/ _jsx(FeatureFeedbackInputSection, {
                    viewContent: viewContent,
                    userComment: userComment,
                    setUserComment: setUserComment
                }),
                /*#__PURE__*/ _jsx(FeatureFeedbackEmailSection, {
                    email: email,
                    emailConsent: emailConsent,
                    setEmailConsent: setEmailConsent
                }),
                /*#__PURE__*/ _jsx(FeatureFeedbackFooterSection, {
                    onSubmitClick: onSubmitClick,
                    submitDisabled: (viewContent === null || viewContent === void 0 ? void 0 : viewContent.scoreRequired) && score === NO_SCORE
                })
            ]
        })
    });
}
export const FeatureFeedback = FeatureFeedbackInternal;
FeatureFeedbackTitleSection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
FeatureFeedbackScoreSection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
FeatureFeedbackChecksSection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
FeatureFeedbackInputSection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
FeatureFeedbackEmailSection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
FeatureFeedbackFooterSection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
